import { forwardRef } from 'react';
import './buttonTemplate.css';

const ButtonTemplate = forwardRef(({
    click,
    background,
    cor,
    width,
    qtdColuna,
    textTransform,
    children,
    pointerEvents,
    tabIndex,
    onKeyDown,
    padding,
    fontSize,
    type = 'button',
    style,
    className,
    disabled,
    apiCarregando
}, ref) => {

    return (
        <button
            ref={ref}
            tabIndex={apiCarregando ? -1 : tabIndex}
            className={`button-template${className ? ` ${className}` : ''}`}
            disabled={apiCarregando ? true : disabled}
            onClick={click}
            onKeyDown={onKeyDown}
            style={{
                background: background,
                color: cor,
                gridColumn: qtdColuna,
                pointerEvents: apiCarregando ? 'none' : pointerEvents,
                padding: padding,
                fontSize: fontSize,
                width: width,
                textTransform: textTransform,
                ...(style || {})
            }}
            type={type}
        >
            {children}
        </button>
    );
});

export default ButtonTemplate;